import { MenuItem, TextField } from "@mui/material";
import { FilterType, statuses } from "../../utils/filters";
import { ChangeEvent, useCallback } from "react";
import { usePlansFilter } from "../../hooks/usePlansFilter";

interface FilterProps {
  current: FilterType;
}

const Filter = ({ current }: FilterProps) => {
  const [filter, setFilter] = usePlansFilter(current.name);

  const handleOnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setFilter(e.target.value);
    },
    [setFilter]
  );

  return (
    <TextField
      size="small"
      select
      label={current.placeholder}
      value={filter}
      onChange={handleOnChange}
      sx={{ width: "200px" }}
    >
      <MenuItem value="">All</MenuItem>
      {statuses.map((s) => (
        <MenuItem key={s} value={s}>
          {s}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default Filter;
